<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import { cn } from '@/lib/utils'

const { toasts, dismiss } = useToast()
</script>

<template>
  <div class="fixed bottom-0 right-0 z-50 flex flex-col gap-2 p-4 max-w-md w-full">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="cn(
          'relative rounded-lg border p-4 pr-8 shadow-lg bg-background',
          toast.variant === 'destructive' && 'border-destructive bg-destructive text-destructive-foreground'
        )"
      >
        <button
          class="absolute right-2 top-2 rounded-md p-1 opacity-70 hover:opacity-100"
          @click="dismiss(toast.id)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6 6 18M6 6l12 12"/>
          </svg>
        </button>
        <div v-if="toast.title" class="font-semibold">{{ toast.title }}</div>
        <div v-if="toast.description" class="text-sm opacity-90">{{ toast.description }}</div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
